import React, { useState } from 'react';
import {
  FDContentContainer, FDStack,
} from '@facet-wealth/design';
import UpdatedScenarioChartWithEmphasizedItems from 'Organisms/UpdatedScenarioChartWithEmphasizedItems';
import { PathSelectors } from 'Views/Page/Content/Templates/roadmapExplorerPageTemplate/pathSelectors';
import useMobileLayout from 'Hooks/useMobileLayout';

const RoadmapDeliverableDashboardChart = ({ resource }) => {
  const paths = resource.attr('paths')?.resources()?.list() ?? [];
  const [selectedPath, setSelectedPath] = useState(paths[0]?.id());
  const chartResource = resource.attr('chart')?.resources()?.head();
  const isMobile = useMobileLayout();

  return (
    <FDContentContainer maxWidth="xl">
      <FDStack
        direction={'column'}
        spacing={2}
        justifyContent={'center'}
        alignItems={'center'}
        width={'100%'}
        paddingX={isMobile ? 0 : 4}
        height={'50vh'}
        minHeight={'300px'}
      >
        {chartResource && paths.length > 0 ? (
          <>
            <FDStack direction={'column'} spacing={2} justifyContent={'center'} alignItems={'center'}>
              <PathSelectors
                selectedPath={selectedPath}
                setSelectedPath={setSelectedPath}
                paths={resource.attr('paths').resources().list()}
              />
            </FDStack>
            <UpdatedScenarioChartWithEmphasizedItems
              selectedDataSetId={selectedPath}
              chartDataSourceIdsToShow={paths.map(path => path.id())}
              chartDataResource={chartResource}
              showLegend={false}
            />
          </>
        ) : null}
      </FDStack>
    </FDContentContainer>
  );
};

export { RoadmapDeliverableDashboardChart };
